<template>
  <div v-if="$route.name == 'DiscountApply'" class="btn-floating2">
    <span style="margin-right:3px;">{{ count }}건 선택 :</span>
    <b> 최대 {{ calPrice | number }}원 할인</b>
  </div>
  <div v-else class="btn-floating">
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:10px;">
    <path d="M13.5833 16.25V14.1667C13.5833 14.0451 13.5443 13.9453 13.4661 13.8672C13.388 13.7891 13.2882 13.75 13.1667 13.75H11.9167V7.08333C11.9167 6.96181 11.8776 6.86198 11.7995 6.78385C11.7214 6.70573 11.6215 6.66667 11.5 6.66667H7.33333C7.21181 6.66667 7.11198 6.70573 7.03385 6.78385C6.95573 6.86198 6.91667 6.96181 6.91667 7.08333V9.16667C6.91667 9.28819 6.95573 9.38802 7.03385 9.46615C7.11198 9.54427 7.21181 9.58333 7.33333 9.58333H8.58333V13.75H7.33333C7.21181 13.75 7.11198 13.7891 7.03385 13.8672C6.95573 13.9453 6.91667 14.0451 6.91667 14.1667V16.25C6.91667 16.3715 6.95573 16.4714 7.03385 16.5495C7.11198 16.6276 7.21181 16.6667 7.33333 16.6667H13.1667C13.2882 16.6667 13.388 16.6276 13.4661 16.5495C13.5443 16.4714 13.5833 16.3715 13.5833 16.25ZM11.9167 4.58333V2.5C11.9167 2.37847 11.8776 2.27865 11.7995 2.20052C11.7214 2.1224 11.6215 2.08333 11.5 2.08333H9C8.87847 2.08333 8.77865 2.1224 8.70052 2.20052C8.6224 2.27865 8.58333 2.37847 8.58333 2.5V4.58333C8.58333 4.70486 8.6224 4.80469 8.70052 4.88281C8.77865 4.96094 8.87847 5 9 5H11.5C11.6215 5 11.7214 4.96094 11.7995 4.88281C11.8776 4.80469 11.9167 4.70486 11.9167 4.58333ZM20.25 10C20.25 11.8142 19.803 13.4874 18.9089 15.0195C18.0148 16.5516 16.8016 17.7648 15.2695 18.6589C13.7374 19.553 12.0642 20 10.25 20C8.43576 20 6.76259 19.553 5.23047 18.6589C3.69835 17.7648 2.48524 16.5516 1.59115 15.0195C0.697049 13.4874 0.25 11.8142 0.25 10C0.25 8.18576 0.697049 6.51259 1.59115 4.98047C2.48524 3.44835 3.69835 2.23524 5.23047 1.34115C6.76259 0.447049 8.43576 0 10.25 0C12.0642 0 13.7374 0.447049 15.2695 1.34115C16.8016 2.23524 18.0148 3.44835 18.9089 4.98047C19.803 6.51259 20.25 8.18576 20.25 10Z" fill="#C94D4D"/>
    </svg>
    <b>{{ nameText }}</b>을 등록해주세요
  </div>
</template>

<script>
export default {
  props: {
    nameText: String,
    insurePrice: String
  },
  computed: {
    count () {
      let checkedItem
      return checkedItem = this.$store.state.discountList.filter(o => o.check == true).length
    },
    calPrice () {
      let totalRate = 0
      let checkedItem = this.$store.state.discountList.filter(o => o.check == true)
      for(let i=0; i < checkedItem.length; i++) {
        if(checkedItem[i].rate2 == '') {
          totalRate = totalRate + Number(checkedItem[i].rate1)
        } else {
          totalRate = totalRate + Number(checkedItem[i].rate2)
        }
      }
      return Math.floor(Number(this.insurePrice) / 100 * totalRate)
    }
  }
}
</script>

<style lang="scss">
.btn-floating{
  position:fixed;
	width: 235px;
  height: 36px;
	/* bottom:140px; */
  /* right:140px; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 22px 4px 22px;
  left: calc(50% - 235px/2);
  /* top: calc(89% - 36px/2 - 81px); */
  bottom: 155px;
  background: linear-gradient(0deg, rgba(201, 77, 77, 0.1), rgba(201, 77, 77, 0.1)), #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 30px;

  font-family: NanumSquareOTF;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
  /* identical to box height, or 175% */
  letter-spacing: -0.32px;
  b {
    color: #CB4949;
  }
}
.btn-floating2 {
  position:fixed;
	width: 235px;
  height: 36px;
	/* bottom:140px; */
  /* right:140px; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 22px 4px 22px;
  left: calc(50% - 235px/2);
  top: calc(100% - 36px/2 - 81px);
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 30px;

  font-family: NanumSquareOTF;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  /* identical to box height, or 175% */
  letter-spacing: -0.32px;
  b {
    color: #CB4949;
  }
}
</style>